import { render, staticRenderFns } from "./IconCalculator.vue?vue&type=template&id=202cc3ce&scoped=true"
import script from "./IconCalculator.vue?vue&type=script&lang=js"
export * from "./IconCalculator.vue?vue&type=script&lang=js"
import style0 from "./IconCalculator.vue?vue&type=style&index=0&id=202cc3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202cc3ce",
  null
  
)

export default component.exports